import { userInfoAtom } from '@/store/root'

const useRoles = () => {
  const userInfo = useAtomValue(userInfoAtom)

  const roles = useMemo(() => {
    const idInTypeList = userInfo?.idInTypeList
    const type = idInTypeList?.map(item => item.type).filter(Boolean)
    return { idInTypeList, type }
  }, [userInfo])

  return roles
}

export default useRoles
